import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import mathis from "../assets/bebe/mathis.jpg"
import louna from "../assets/bebe/louna.jpg"
import mariloue from "../assets/bebe/mariloue.jpg"
import tc from "../assets/bebe/tc.jpg"
import img1 from "../assets/img/bandeau.jpg";
import mathis1 from "../assets/bebe/louna.jpg";
import mathis2 from "../assets/bebe/louna2.jpg";


export const Louna = () => {
  return (
    <>

      <div className="banner-titre-container">
        <img src={img1} className="back-img" />
        <div className='over-banner'>
          <div className='info-banner'>
            <h1 className='banner-title'> Bienvenue sur Terre petit ange ...</h1>
          </div>
        </div>
      </div>

      <div className='block-container bottom-space side-space-margin top-space-margin'>
        <Row>
          <Col xs={12} lg={9}>

            <div className='central-block central-block-margin'>
              <div id="left"> <strong style={{
                textAlign: 'center',
                fontFamily: 'Raleway, sans-serif',
                fontWeight: 600,
                fontSize: '30px'
              }}>Accueil des Nouveau-Nés : Bébé-Channeling
              </strong>
                <h2 align="right"><span class="style4"><span class="style7"><img src={mathis2} alt="" width="88" height="86" /></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></h2>
                <span class="style11"><strong>Ame de Louna, 3 ans aujourd'hui :</strong></span><br />	 <br />
                <p class="style9">"Se laisser glisser dans une nouvelle Vie, presque à regret ... Que savez-vous des pensées derrière le visage angélique de vos chérubins fraîchement nés dans vos draps accueillants ? Je suis pleine de bonnes volontés ... à condition que l'on respecte les miennes. J'ai un besoin pressant de modeler ma vie, mes habitudes, selon mon ressenti. Mes possibilités du moment inhibent mes envies d'avancée ; être obligée d'attendre que la langue, les centres 'cervotiques' se forment pour prendre possession de mes moyens m'est pénible ... d'où mes crises. Je m'entends crier au-dehors, alors que dedans, je me sens si impuissante. Alors, je crie pour masquer mes peurs. </p><br />
                <p class="style9">Je suis plus préoccupée par mes avancées que par les câlins ... même si les câlins font partie intégrante de mes privilèges de bébé !</p><br />
                <p class="style9">Je veux le tout et son contraire, c'est si  contradictoire à l'intérieur de moi. Je suis déjà fatiguée d'être bébé, pressée de grandir pour quitter ce corps maladroit. </p><br />
                <p class="style9">J'aspire à me dépasser, à voir les choses de haut, à faire les choses à ma tête, à faire autrement que les autres. <strong>Je veux ouvrir des chemins, là où il n'y en a pas.</strong> Je veux ouvrir ces portes fermées. Je veux montrer aux autres que l'impossible n'existe pas. </p><br />
                <p class="style9">Chemin de vie révolutionnaire. Les rails de ma Famille me servent à mieux me démarquer. </p><br />
                <p class="style9">J'ai une Maman à ma mesure, à ma hauteur. Je sais que tout ira bien. Je suis bien entourée. Je suis bien née. J'ai fait le bon choix. </p><br />
                <p class="style9">Merci, mes soeurs. Merci Papa. </p><br />
                <p class="style9">Merci. Vous êtes ce que vous êtes, merveilleusement, et je suis qui je suis. LOUNA"</p><br />
              </div>

            </div>
          </Col>
          <Col xs={12} lg={3}>
            <div className='right-block'>
              <div id="right">
                <h3 class="style13"></h3>
                <h3 align="center" class="style5"><span class="style9"><img src={mathis1} alt="" width="107" height="126" /></span></h3>
                <p align="left" class="style11"><strong>Louna :</strong></p>
                <p align="left" class="style10"><i>"Je veux ouvrir des chemins, là où il n'y en a pas ..."</i></p>
                <p align="left" class="style11"><strong>Maman de Louna :</strong></p>
                <p align="left" class="style10"><i>"C'est exactement cela ! Je comprends mieux maintenant les réactions de ma fille. J'aurais dû faire ce channeling plus tôt. Merci pour cette aide précieuse."</i></p>

                <div className='bouton-rectangle-container'>
                  <Link to={'/contact'} className='bouton-rectangle-music'>
                    Me contacter
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

